import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import LandingPage from './LandingPage';
import BlogPage from './BlogPage';
import { prefetchBlog } from './blog/blogCache';

// Ana sayfa ile blog tek yapı olarak çalışır: ana sayfa bir kez kurulur, blogdayken yalnız gizlenir
// (silinip yeniden çizilmez; kaydırma konumu, fiyatlar, script durumu korunur). Blog sayfaları gelip
// gider. Panel/giriş gibi başka bir yola geçilince bu bileşen kalkar ve ana sayfa stilleri de kalkar.
export const isBlogPath = (pathname) => pathname === '/blog' || pathname.startsWith('/blog/');

// /blog/ → '' (liste), /blog/sayfa/3/ → 'sayfa-3' (liste 3. sayfa), /blog/<yazı>/ → yazının adı.
const blogSlug = (pathname) => {
  const pageMatch = pathname.match(/^\/blog\/sayfa\/(\d+)/);
  if (pageMatch) return Number(pageMatch[1]) > 1 ? `sayfa-${Number(pageMatch[1])}` : '';
  const match = pathname.match(/^\/blog\/([^/]+)/);
  return match ? decodeURIComponent(match[1]) : '';
};

export default function PublicSite({ isLoggedIn, onNavigate }) {
  const { pathname } = useLocation();
  const onBlog = isBlogPath(pathname);
  // Giriş yapmış kullanıcıya ana sayfa gösterilmez (App '/' yolunu panele yönlendirir).
  const landingAllowed = !isLoggedIn;
  const [landingMounted, setLandingMounted] = useState(landingAllowed && !onBlog);

  useEffect(() => {
    if (landingAllowed && !onBlog) setLandingMounted(true);
  }, [landingAllowed, onBlog]);

  useEffect(() => {
    if (!onBlog && landingAllowed) prefetchBlog();
  }, [onBlog, landingAllowed]);

  return (
    <>
      {landingAllowed && landingMounted && <LandingPage active={!onBlog} onNavigate={onNavigate} />}
      {onBlog && <BlogPage slug={blogSlug(pathname)} />}
    </>
  );
}
